import * as React from 'react';

function Header() {
    return (
        <header className="header center-vertical">
            <h1 className="darkgray pacifico">Polyfest</h1>
        </header>
    );
}

export default Header;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/header.tsx